"use strict";

var _interopRequireDefault = require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _reg_header = _interopRequireDefault(require("../../components/landingpage/reg_header.vue"));
var _reg_footer = _interopRequireDefault(require("../../components/landingpage/reg_footer.vue"));
var _reg_login = _interopRequireDefault(require("../../components/landingpage/reg_login.vue"));
var _reg_carousel = _interopRequireDefault(require("../../components/landingpage/reg_carousel.vue"));
var _api = require("../../api/api");
var _default = exports.default = {
  name: 'reg_first',
  components: {
    regHeader: _reg_header.default,
    regFooter: _reg_footer.default,
    regLogin: _reg_login.default,
    regCarousel: _reg_carousel.default
  },
  data: function data() {
    return {
      uuid: '',
      //模板创建者id
      pageId: '',
      //模板id
      userId: '',
      template: '',
      carouselWidth: '620px',
      landingPageTitle: '',
      //落地页标题
      landingPageJumpLink: '',
      //注册后跳转链接
      landingpageImg: [],
      //落地页所有图片数据
      bgData: {},
      //落地页背景图片数据
      carouselData: [],
      //落地页轮播图片数据
      bgSrc: '' //落地页背景图片
    };
  },
  created: function () {
    var _created = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            this.pageId = this.$route.query.pageId ? this.$route.query.pageId : '';
            this.userId = this.$route.query.userId ? typeof this.$route.query.userId == 'string' ? this.$route.query.userId : this.$route.query.userId[0] : '';
            this.template = this.$route.query.template ? this.$route.query.template : '';
            _context.next = 5;
            return this.toGetLandingPage();
          case 5:
            _context.next = 7;
            return this.landingPageClick();
          case 7:
            if (this.landingPageTitle) {
              document.title = this.landingPageTitle;
            }
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }(),
  methods: {
    // 获取模板配置图
    toGetLandingPage: function () {
      var _toGetLandingPage = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var that, param, _yield$apiGetLandingP, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              that = this;
              param = {
                pageId: that.$route.query.pageId
              }; // let paramete = {jsonParamete: JSON.stringify(param)}
              _context2.next = 4;
              return (0, _api.apiGetLandingPage)(param);
            case 4:
              _yield$apiGetLandingP = _context2.sent;
              data = _yield$apiGetLandingP.data;
              if (data.code == '200') {
                that.uuid = data.data.uuid;
                that.landingPageJumpLink = data.data.landingPageJumpLink;
                that.landingPageTitle = data.data.landingPageTitle;
                that.landingpageImg = data.data.imgList;
                this.landingpageImg.filter(function (item) {
                  if (item.imgType == '1') {
                    // 背景图数据
                    that.bgData = item;
                  } else if (item.imgType == '2') {
                    that.carouselData.push(item);
                  }
                });
                // console.log("注册后跳转链接:",that.landingPageJumpLink)
                // 背景图
                that.bgSrc = that.bgData.imgUrl ? that.bgData.imgUrl : '';
              }
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function toGetLandingPage() {
        return _toGetLandingPage.apply(this, arguments);
      }
      return toGetLandingPage;
    }(),
    // 点击事件上报
    landingPageClick: function () {
      var _landingPageClick = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var that, param, _yield$apiGetLandingP2, data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              that = this;
              param = {
                pageId: that.pageId
              };
              _context3.next = 4;
              return (0, _api.apiGetLandingPageClick)(param);
            case 4:
              _yield$apiGetLandingP2 = _context3.sent;
              data = _yield$apiGetLandingP2.data;
              if (data.code == '200') {
                console.log(data.msg);
              }
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function landingPageClick() {
        return _landingPageClick.apply(this, arguments);
      }
      return landingPageClick;
    }()
  }
};